<!-- 图片上传 -->
<template>
  <div class="form_upload_img_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name "
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <van-divider v-if="layout === 'vertical'" />
    <van-field
      :label="layout === 'horizontal' ? option.label : null "
      :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed form_label_vertical_center' : 'form_label_vertical_center') : '' "
      :name="option.name"
      :error-message="errorMessage"
      :rules="[
        {
          validator: asyncValidator,
          message: '数据格式有误，请输入正确内容！',
        },
      ]"
    >
      <template #input>
        <van-uploader
          :before-read="BeforeImgUpload"
          :after-read="UploadImgToServer"
          :class="layout === 'horizontal' ? 'bc_picker_btn_horizontal' : 'bc_picker_btn' "
          :fileList="fileList"
          :before-delete="BeforeImgDelete"
          :max-count="1"
          class="business_card_uploader"
        >
          <div class="bcard_upload_btn">
            <div class="bcard_upload_btn_body">
              <div class="bcard_upload_icon_wrap">
                <van-icon
                  color="#dcdee0"
                  name="card"
                  class="bcard_upload_icon"
                />
              </div>
              <div class="bcard_upload_tips">{{option.description}}</div>
            </div>
          </div>
        </van-uploader>
        <div
          v-show="loading"
          class="bcard_preview_load_wrap"
        >
          <van-loading
            class="bcard_loading"
            size="24px"
            vertical
          >{{$t('book.form.discern')}}</van-loading>
        </div>
      </template>
    </van-field>

  </div>
</template>

<script>
import { UploadAuthentication, GetAiOcr } from '@a/js/api/public'
import { UploadYun } from '@a/js/api/uploadyun'
import apiObj from '@a/js/api.js'
export default {
  name: 'FormUploadImg',
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      fileList: [
        // { url: 'https://img.yzcdn.cn/vant/leaf.jpg' }
      ],
      imgList: [],
      error: false,
      errorMessage: '',
      params: {},
      loading: false
    }
  },

  components: {},
  watch: {
    imgList: {
      handler(data) {
        let tempList = []
        data.map((item) => {
          tempList.push({
            url: apiObj.VUE_APP_BASE_CDN + item,
          })
        })
        this.fileList = tempList
      },
      deep: true,
      immediate: true,
    },
    option: {
      handler() {
        this.InitImgArr()
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    //文件校验
    BeforeImgUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'

      if (!(isJPG || isPNG)) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.uploadImg'),
        })
      }
      const isLt2M = file.size / 1024 / 1024 < 15
      if (!isLt2M) {
        this.$notify({
          type: 'warning',
          message: this.$t('notify.uploadSize15'),
        })
      }
      return (isJPG || isPNG) && isLt2M





    },
    //格式校验方法
    asyncValidator(value) {
      return new Promise((resolve) => {
        if (value.length > 0) {
          resolve(this.SetCheckSuccMsg())
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('book.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    },
    // 上传图片到服务器
    UploadImgToServer(data) {
      let file = new File([data.file], (new Date()).getTime() + '_' + data.file.name, { type: data.file.type })
      this.BeforeUploadAuth(file)
    },
    // 文件上传前鉴权
    BeforeUploadAuth(file) {
      let resdata = {
        module: 'business',
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        path: '/form/business_card/' + file.name,
      }
      UploadAuthentication(resdata)
        .then((res) => {
          file.status = 'uploading'
          const formData = new FormData()
          formData.append('file', file)
          formData.append('policy', res.data.policy)
          formData.append('authorization', res.data.authorization)
          UploadYun(formData)
            .then((res) => {
              file.status = 'done'
              this.imgList.push(res.url)
              this.$emit('listenImgListChanged', this.option.name, this.imgList)

              this.getBusinessCard(res.url)
              this.$notify({
                type: 'success',
                message: this.$t('notify.uploadSuc'),
              }).then(() => {
                this.asyncValidator(this.fileList)
              })
            })
            .catch(() => {
              file.status = 'failed'
            })
        })
        .catch(() => {
          file.status = 'failed'
        })
    },
    // 点击删除文件
    BeforeImgDelete(info) {
      // console.log(info)
      if (info.status === 'failed') {
        let delIndex = ''
        this.fileList.map((item, index) => {
          if (item.file.name === info.file.name) {
            delIndex = index
          }
        })
        this.fileList.splice(delIndex, 1)
      } else {
        this.imgList.map((item, index) => {
          if (
            item.substring(item.lastIndexOf('/') + 1) ===
            info.url.substring(info.url.lastIndexOf('/') + 1)
          ) {
            this.imgList.splice(index, 1)
          }
        })
        this.$emit('listenImgListChanged', this.option.name, this.imgList)
      }
    },
    // 初始化数据数组
    InitImgArr() {
      this.$emit('listenImgListChanged', this.option.name, this.imgList)
    },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 识别名片
    getBusinessCard(url) {
      this.loading = true
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        type: 'businessCard',
        imagePath: url
      }
      GetAiOcr(data).then(res => {
        // console.log(res)
        this.$emit('listenAiBusinessCard', res.data)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },

  mounted() {
    this.GetParamsData()
  },
}
</script>
<style lang="less" scoped>
.form_upload_img_wrap {
  .bc_picker_btn {
    margin-left: 8px;
    margin-right: 8px;
    width: 100%;
  }
  .business_card_uploader {
    width: 100%;
    position: relative;
  }
  .bcard_preview_load_wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    .bcard_loading {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 80px;
      transform: translateX(-50%) translateY(-50%);
      // color: var(--background);
      color: #06f;
      .van-loading__text {
        // color: var(--background);
        color: #06f;
      }
    }
  }

  :v-deep .van-uploader__upload {
    margin: 0;
  }
  :v-deep .van-uploader__input-wrapper {
    width: 100%;
  }
  :v-deep .van-uploader__preview {
    margin: 0;
    border-radius: 8px;
    background: #f7f8fa;
    width: 100%;
    padding: 5px 0;
  }
  :v-deep .van-uploader__preview-image {
    max-width: 98%;
    width: fit-content;
    margin: 0 auto;
    height: 130px;
  }
  :v-deep .van-image__img {
    width: auto;
  }
  .bcard_upload_btn {
    width: 100%;
    min-height: 140px;
    background: #f7f8fa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    .bcard_upload_btn_body {
      margin: 0 auto;
      padding: 15px;
      text-align: center;
      .bcard_upload_icon {
        font-size: 40px;
      }
      .bcard_upload_tips {
        font-size: 14px;
        line-height: 1.2;
        text-align: justify;
        color: #999;
      }
    }
  }
}
</style>
